module.exports = __webpack_public_path__ + "static/media/referral_badge_icon_400x200px.dbd1c9bd.png";